import Mx from "mxdraw";
const { MxDbAlignedDimension } = Mx;

// 尺寸测量
class rlAlignedDimension extends MxDbAlignedDimension {
  constructor(options) {
    super(options);
    this.classTypeName = "rlDimension";
    this.m_groupName = "rlAlignedDimension";
  }

  // 设置尺寸测量的两个点
  setPoints(points) {
    super.setPoints(points);
  }

  // 获取类型名称
  getTypeName() {
    return super.getTypeName();
  }

  // 获取尺寸文本
  getDimText() {
    return super.getDimText();
  }

  // 在世界坐标系中绘制
  worldDraw(pWorldDraw) {
    super.worldDraw(pWorldDraw);
  }

  // 设置测量的起始点
  setPoint1(pt1) {
    super.setPoint1(pt1);
  }

  // 设置测量的结束点
  setPoint2(pt2) {
    super.setPoint2(pt2);
  }

  // 设置颜色
  setColor(color) {
    return super.setColor(color);
  }
}

export { rlAlignedDimension };
